import { AxiosResponse } from 'axios'
import apiClient from 'api/common/common'
import { EarningResponse } from 'api/common/responses'
import { Status } from 'api/common/statuses'
import { PositionNumberType } from './common/constants'

/**
 * 売上取得API
 * @param positionNumber
 * @param monthAgo
 * @param callback
 */
const earningsAPI = async (positionNumber: PositionNumberType, monthAgo: number, callback: (response: EarningResponse) => void) => {
  await apiClient.get(`/earnings/${positionNumber}/${monthAgo}`).then((response: AxiosResponse<EarningResponse>) => {
    const status = response?.headers['x-aqc-status'] ?? 'failed'
    const apiResult = response?.data
    if (status === Status.Success && apiResult) {
      callback(apiResult)
    }
  })
}

export default earningsAPI
